<template>
  <VDialogV3
    closable
    :title="`Закрытие заказа ${ $core.utils.string.formatWithDelimiter(orderPosition.id) }`"
  >
    <VTextarea
      v-model="reasonText"
      label="Причина закрытия"
      layout="vertical"
      placeholder="Укажите причину закрытия"
    />

    <VInputNumberRusV2
      v-model="localPosition.qty"
      :type="Qty"
      label="Количество"
      layout="vertical"
      :unit="localPosition.unit"
    >
      <template #helper-text>
        Количество всего собранного и отгруженного включая брак и недостачу.
        <br>
        В работе: {{ localPosition.shipmentStatus.inWork.format(localPosition.unit) }}.
      </template>
    </VInputNumberRusV2>

    <OrderPositionComplaintInputs
      :local-position="localPosition"
    />

    <template #footer>
      <VButton
        theme="primary"
        @click="closePosition"
      >
        Закрыть заказ
      </VButton>
      <VButton @click="$core.dialogs.OrderPositionCloseCard.hide()">
        Отменить
      </VButton>
    </template>
  </VDialogV3>
</template>

<script lang="ts">
import type OrderPosition from '@/domains/Orders/OrderPosition';
import OrdersService      from '@/domains/Orders/OrdersService';
import Qty                from '@/core/types/Qty';

import OrderPositionComplaintInputs
  from '@/domains/Orders/components/OrderPositionComplaintInputs/OrderPositionComplaintInputs.vue';

export default defineComponent({
  name: 'OrderPositionCloseCard',

  components: {
    OrderPositionComplaintInputs,
  },

  props: {
    orderPosition: {
      type:     Object as PropType<OrderPosition>,
      required: true,
    },
  },

  setup() {
    return {
      /** Класс нужен шаблону для :type у VInputNumberRusV2 */
      Qty,
    };
  },

  data() {
    return {
      /** Правим копию: пока заказ не закрыт, оригинал в реестре менять нельзя. */
      localPosition: this.$core.utils.cloneDeep(this.orderPosition),
      reasonText:    undefined as unknown as string,
    };
  },

  created() {
    /** Закрываем на том, что реально прошло через склад: собранное плюс
     *  отгруженное. Qty складывается методом — оператор `+` спровоцировал бы
     *  valueOf и исключение неявного приведения. */
    this.localPosition.qty = this.localPosition.shipmentStatus.shipped
      .plus(this.localPosition.shipmentStatus.assembled);
  },

  methods: {
    async closePosition(): Promise<void> {
      const isClosed = await OrdersService.closePosition(
        this.localPosition,
        this.reasonText,
      );

      if (isClosed) {
        this.$core.dialogs.OrderPositionCloseCard.resolve();
      }
    },
  },
});
</script>
